import { QueryKeys } from "@cede/utils";
import { useQuery } from "@tanstack/react-query";

export const useConfig = () => {
  const { data: config, refetch } = useQuery({
    queryKey: [QueryKeys.CONFIG],
    queryFn: () => Promise.resolve({ limit_order_ui: true }),
    staleTime: Infinity,
    gcTime: Infinity,
    refetchOnWindowFocus: false,
  });
  return {
    config,
    refetchConfig: refetch,
  };
};
